import { useState } from 'react'
import { Grid, GridItem, IconButton, Img } from '@chakra-ui/react'
import { HiX } from 'react-icons/hi'
import { ImagePopup } from '@/components/ImagePopup'

type ImagesProps = {
  size?: 'sm' | 'md'
  images: string[]
  changeFormImages?: (images: string[]) => void
}

export const Images = ({ size = 'md', images, changeFormImages }: ImagesProps) => {
  const [selectedImage, setSelectedImage] = useState<string>()
  const getGridTemplate = () => {
    switch (images.length) {
      case 1:
        return {
          templateRows: '',
          templateColumns: '',
        }
      case 2:
        return {
          templateRows: '',
          templateColumns: 'repeat(2, 2fr)',
        }
      case 3:
        return {
          templateRows: 'repeat(2, 1fr)',
          templateColumns: 'repeat(2, 2fr)',
        }
      case 4:
        return {
          templateRows: 'repeat(2, 2fr)',
          templateColumns: 'repeat(2, 2fr)',
        }
    }
  }

  const getImageHeightSm = (imageIndex: number) => {
    switch (imageIndex) {
      case 1:
        return images.length == 4 ? '80px' : '165px'
      case 2:
        return images.length == 2 ? '165px' : '80px'
      case 3:
        return '80px'
      case 4:
        return '80px'
    }
  }

  const getImageHeightMd = (imageIndex: number) => {
    switch (imageIndex) {
      case 1:
        return images.length == 4 ? '145px' : '300px'
      case 2:
        return images.length == 2 ? '300px' : '145px'
      case 3:
        return '145px'
      case 4:
        return '145px'
    }
  }

  const getGridItemColSpan = (imageIndex: number) => {
    return images.length == 3 && imageIndex == 1 ? 1 : undefined
  }

  const getGridItemRowSpan = (imageIndex: number) => {
    return images.length == 3 && imageIndex == 1 ? 2 : undefined
  }

  const template = getGridTemplate()

  return (
    <>
      <Grid
        mt={3}
        gap={images.length == 1 ? 1 : 2}
        templateRows={template?.templateRows}
        templateColumns={template?.templateColumns}
      >
        {images.map((image, index) => {
          const imageIndex = index + 1
          return (
            <GridItem
              key={index}
              position={'relative'}
              colSpan={getGridItemColSpan(imageIndex)}
              rowSpan={getGridItemRowSpan(imageIndex)}
            >
              {/* FIXME: autosuggestのやつと被るため、本来関係のないカード側で調整している */}
              <Img
                loading={'lazy'}
                zIndex={-1}
                w={'100%'}
                h={size == 'md' ? getImageHeightMd(imageIndex) : getImageHeightSm(imageIndex)}
                objectFit="cover"
                borderRadius={4}
                src={image}
                onClick={(e) => {
                  e.preventDefault()
                  setSelectedImage(image)
                }}
              />

              {changeFormImages && (
                <IconButton
                  top={2}
                  right={5}
                  zIndex={999}
                  opacity={0.6}
                  bg="gray.500"
                  borderRadius={'50%'}
                  position={'absolute'}
                  colorScheme={'gray.500'}
                  aria-label="imageDelete"
                  icon={<HiX />}
                  onClick={() => {
                    const newImages = images
                    newImages.splice(index, 1)
                    changeFormImages(newImages)
                  }}
                />
              )}
            </GridItem>
          )
        })}
      </Grid>
      <ImagePopup
        imageUrl={selectedImage}
        onClose={() => {
          setSelectedImage(undefined)
        }}
      />
    </>
  )
}
